<template>
  <header class="header">
    <nav class="nav container">
      <router-link to="/" class="logo" @click="closeMenu">
        <img v-if="siteSettings.logo" :src="siteSettings.logo" :alt="siteSettings.site_name" class="logo-image" />
        <span class="logo-text">{{ siteSettings.site_name }}</span>
      </router-link>

      <button class="nav-toggle" :class="{ open: isMenuOpen }" @click="toggleMenu" aria-label="Открыть меню">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <ul :class="['nav-menu', { open: isMenuOpen }]">
        <li><router-link to="/" :class="{ active: isActive('/') }" @click="closeMenu">Главная</router-link></li>
        <li><router-link to="/hsk" :class="{ active: isActive('/hsk') }" @click="closeMenu">Всё об HSK</router-link></li>
        <li><router-link to="/prices" :class="{ active: isActive('/prices') }" @click="closeMenu">Цены</router-link></li>
        <li><router-link to="/teachers" :class="{ active: isActive('/teachers') }" @click="closeMenu">Преподаватели</router-link></li>
        <li><router-link to="/reviews" :class="{ active: isActive('/reviews') }" @click="closeMenu">Отзывы</router-link></li>
        <li class="nav-menu-dropdown" 
            @mouseenter="handleMouseEnter"
            @mouseleave="handleMouseLeave">
          <a href="#" 
             :class="{ active: isCoursesActive }" 
             @click.prevent="toggleCoursesDropdown">
            Курсы
            <span class="dropdown-arrow" :class="{ open: showCoursesDropdown }">▼</span>
          </a>
          <ul class="dropdown-menu" :class="{ open: showCoursesDropdown }">
            <li>
              <router-link 
                to="/courses-hsk" 
                :class="{ active: isActive('/courses-hsk') }"
                @click="closeCoursesDropdown">
                Курсы HSK
              </router-link>
            </li>
            <li v-for="category in visibleCategories" :key="category.id">
              <router-link 
                :to="`/category/${category.slug}`" 
                :class="{ active: isActiveCategory(category.slug) }"
                @click="closeCoursesDropdown">
                {{ category.name }}
              </router-link>
            </li>
          </ul>
        </li>
        <li><router-link to="/contacts" :class="{ active: isActive('/contacts') }" @click="closeMenu">Контакты</router-link></li>
        <li class="nav-menu-cta">
          <a href="/school/" class="cta-button mobile-cta" @click="closeMenu">{{ isLoggedIn ? 'Личный кабинет' : 'Учиться' }}</a>
        </li>
      </ul>

      <a href="/school/" class="cta-button desktop-cta">{{ isLoggedIn ? 'Личный кабинет' : 'Учиться' }}</a>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      siteSettings: {
        site_name: 'Мама я в Китае',
        logo: null
      },
      isMenuOpen: false,
      isLoggedIn: false,
      visibleCategories: [],
      showCoursesDropdown: false
    }
  },
  async mounted() {
    await this.loadSiteSettings()
    await this.loadCategories()
    this.checkAuth()
    this.setupHeaderScrollEffect()
    this.$watch(() => this.$route.path, () => {
      this.isMenuOpen = false
      this.showCoursesDropdown = false
    })
    window.addEventListener('resize', this.handleResize)
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    isActive(path) {
      return this.$route.path === path
    },
    isCoursesActive() {
      return this.$route.path.startsWith('/category/') || this.$route.path === '/courses-hsk'
    },
    isActiveCategory(slug) {
      return this.$route.path === `/category/${slug}`
    },
    async loadCategories() {
      try {
        const response = await fetch('/api/v1/public/product-categories');
        if (response.ok) {
          const data = await response.json();
          this.visibleCategories = data;
        }
      } catch (error) {
        console.error('Error loading categories:', error);
      }
    },
    toggleCoursesDropdown() {
      this.showCoursesDropdown = !this.showCoursesDropdown
    },
    closeCoursesDropdown() {
      this.showCoursesDropdown = false
      this.closeMenu()
    },
    handleMouseEnter() {
      // На десктопе открываем при наведении
      if (window.innerWidth > 1024) {
        this.showCoursesDropdown = true
      }
    },
    handleMouseLeave() {
      // На десктопе закрываем при уходе мыши
      if (window.innerWidth > 1024) {
        this.showCoursesDropdown = false
      }
    },
    checkAuth() {
      const token = localStorage.getItem('studentAccessToken');
      this.isLoggedIn = !!token;
    },
    async loadSiteSettings() {
      try {
        const response = await fetch('/api/v1/public/site-settings');
        if (response.ok) {
          const data = await response.json();
          this.siteSettings = data;
        }
      } catch (error) {
        console.error('Error loading site settings:', error);
      }
    },
    setupHeaderScrollEffect() {
      window.addEventListener('scroll', function() {
        const header = document.querySelector('.header');
        if (header) {
          if (window.scrollY > 100) {
            header.style.background = 'rgba(255, 255, 255, 0.98)';
            header.style.boxShadow = '0 2px 30px rgba(0,0,0,0.15)';
          } else {
            header.style.background = 'rgba(255, 255, 255, 0.95)';
            header.style.boxShadow = '0 2px 30px rgba(0,0,0,0.08)';
          }
        }
      });
    },
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    closeMenu() {
      this.isMenuOpen = false
      this.showCoursesDropdown = false
    },
    handleResize() {
      if (window.innerWidth > 1024) {
        this.isMenuOpen = false
      }
    },
  }
}
</script>

<style scoped>
.header {
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 2px 30px rgba(0,0,0,0.08);
  position: sticky;
  top: 0;
  z-index: 1000;
  padding: 0;
}

.nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  height: 72px;
}

.nav-toggle {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  width: 44px;
  height: 44px;
  border: none;
  background: transparent;
  cursor: pointer;
  padding: 0;
}

.nav-toggle span {
  display: block;
  height: 2px;
  background: #2c3e50;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.logo {
  display: flex;
  align-items: center;
  gap: 12px;
  text-decoration: none;
  color: #2c3e50;
  font-weight: 700;
  font-size: 18px;
}

.logo-image {
  height: 40px;
  width: auto;
}

.logo-text {
  white-space: nowrap;
}

.nav-toggle.open span:nth-child(1) {
  transform: translateY(8px) rotate(45deg);
}

.nav-toggle.open span:nth-child(2) {
  opacity: 0;
}

.nav-toggle.open span:nth-child(3) {
  transform: translateY(-8px) rotate(-45deg);
}

.nav-menu {
  display: flex;
  list-style: none;
  gap: 2rem;
  align-items: center;
  margin: 0;
  padding: 0;
}

.nav-menu a {
  color: #2c3e50;
  text-decoration: none;
  font-weight: 500;
  font-size: 15px;
  transition: color 0.3s ease;
  white-space: nowrap;
}

.nav-menu a:hover {
  color: #e74c3c;
}

.nav-menu-cta {
  display: none;
}

.cta-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 12px 24px;
  background: #e74c3c;
  color: white;
  text-decoration: none;
  border-radius: 8px;
  font-weight: 600;
  font-size: 15px;
  transition: all 0.3s ease;
  white-space: nowrap;
}

.cta-button:hover {
  background: #c0392b;
  transform: translateY(-1px);
}

.desktop-cta {
  display: inline-flex;
}

.mobile-cta {
  display: inline-flex;
  width: 100%;
  justify-content: center;
  margin-top: 8px;
}

@media (max-width: 1024px) {
  .nav-toggle {
    display: flex;
  }

  .desktop-cta {
    display: none;
  }

  .nav-menu {
    position: fixed;
    top: 72px;
    left: 0;
    right: 0;
    background: rgba(255,255,255,0.97);
    backdrop-filter: blur(10px);
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    padding: 24px;
    gap: 16px;
    box-shadow: 0 24px 48px -24px rgba(15,23,42,0.3);
    transform: translateY(-110%);
    opacity: 0;
    pointer-events: none;
    transition: transform 0.25s ease, opacity 0.25s ease;
    z-index: 999;
  }

  .nav-menu.open {
    transform: translateY(0);
    opacity: 1;
    pointer-events: auto;
  }

  .nav-menu li {
    width: 100%;
    text-align: center;
  }

  .nav-menu-cta {
    display: block;
    width: 100%;
    margin-top: 8px;
  }

  .mobile-cta {
    width: 100%;
    max-width: 200px;
  }
}

.nav-menu a.active {
  color: #e74c3c;
  position: relative;
}

.nav-menu a.active::after {
  content: '';
  position: absolute;
  bottom: -8px;
  left: 0;
  right: 0;
  height: 2px;
  background: #e74c3c;
}

@media (max-width: 1024px) {
  .nav-menu a.active::after {
    display: none;
  }
}

/* Выпадающее меню для курсов */
.nav-menu-dropdown {
  position: relative;
}

.nav-menu-dropdown > a {
  display: flex;
  align-items: center;
  gap: 6px;
}

.dropdown-arrow {
  font-size: 10px;
  transition: transform 0.3s ease;
}

.dropdown-arrow.open {
  transform: rotate(180deg);
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  background: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border-radius: 8px;
  list-style: none;
  padding: 8px 0;
  margin: 8px 0 0 0;
  min-width: 200px;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-10px);
  transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease;
  z-index: 1000;
}

.dropdown-menu.open {
  opacity: 1;
  visibility: visible;
  transform: translateY(0);
}

.dropdown-menu li {
  margin: 0;
  width: 100%;
}

.dropdown-menu a {
  display: block;
  padding: 12px 20px;
  color: #2c3e50;
  text-decoration: none;
  transition: background 0.2s ease, color 0.2s ease;
  text-align: left;
}

.dropdown-menu a:hover {
  background: #f8f9fa;
  color: #e74c3c;
}

.dropdown-menu a.active {
  background: #f8f9fa;
  color: #e74c3c;
  font-weight: 600;
}

@media (max-width: 1024px) {
  .nav-menu-dropdown {
    width: 100%;
  }

  .dropdown-menu {
    position: static;
    box-shadow: none;
    background: transparent;
    padding: 0;
    margin: 8px 0 0 20px;
    transform: none;
    opacity: 1;
    visibility: visible;
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.3s ease;
  }

  .dropdown-menu.open {
    max-height: 500px;
  }

  .dropdown-menu a {
    padding: 10px 20px;
    font-size: 14px;
  }
}
</style>
